import React from 'react';

interface Props {
  title: string;
  icon: string;
}

const GroupTitle: React.FC<Props> = ({ title, icon }) => (
  <div className="jg-display-flex jg-flex-aic jg-space-mtmd jg-space-mbsm">
    <img src={icon} alt="" className="jg-icon--medium-small jg-space-mrxs" />
    <h2 className="jg-text jg-color--empress jg-space-mn">{title}</h2>
  </div>
);
export default React.memo(GroupTitle);
